/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
export default class AchievementHeader extends Component {
  oninit(vnode) {
    super.oninit(vnode);
  }
  view() {
    const {
      achievement,
      showDesc,
      actions
    } = this.attrs;
    if (!achievement) {
      return null;
    }
    return m("div", {
      className: "AchievementHeader"
    }, m("div", {
      className: "AchievementHeader-name"
    }, achievement.name()), actions && m("div", {
      className: "AchievementHeader-actions"
    }, actions), showDesc && m("div", {
      className: "AchievementHeader-description"
    }, achievement.description()));
  }
}
flarum.reg.add('glowingblue-gamilytics', 'common/components/AchievementHeader', AchievementHeader);